import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["icon", "type", "children"];
import React from 'react';
import { AlertTriangle, CheckCircle, Info, XCircle } from 'react-feather';
import { Container } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/core";
var icons = {
  default: Info,
  info: Info,
  warning: AlertTriangle,
  success: CheckCircle,
  danger: XCircle
};

var Hint = function Hint(_ref) {
  var _ref$icon = _ref.icon,
      icon = _ref$icon === void 0 ? true : _ref$icon,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'default' : _ref$type,
      children = _ref.children,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var Icon = icons[type];
  return ___EmotionJSX(Container, _extends({
    type: type
  }, rest), icon && ___EmotionJSX("span", null, ___EmotionJSX(Icon, {
    size: 27
  })), ___EmotionJSX("div", null, children));
};

Hint.displayName = 'Hint';
Hint.defaultProps = {
  icon: true
};
export { Hint };

if (typeof Hint !== 'undefined' && Hint && Hint === Object(Hint) && Object.isExtensible(Hint) && !Object.prototype.hasOwnProperty.call(Hint, '__filemeta')) {
  Object.defineProperty(Hint, '__filemeta', {
    configurable: true,
    value: {
      name: "Hint",
      filename: "node_modules/@nejcm/docz-theme-extended/src/gatsby-theme-docz/custom-components/Hint/index.js"
    }
  });
}